import { Location, NavigateFunction } from 'react-router-dom';

import { URL_ARRAY_PARAM_SEPARATOR } from '../constants/constants';

export const encodeUrlArrayParam = (values: string[]): string =>
  encodeURIComponent(values.join(URL_ARRAY_PARAM_SEPARATOR));

export const decodeUrlArrayParam = (raw: string | null): string[] =>
  raw?.length ? decodeURIComponent(raw).split(URL_ARRAY_PARAM_SEPARATOR) : [];

export function buildQueryParams(filters: Record<string, any>): string {
  const params = new URLSearchParams();

  Object.entries(filters).forEach(([filterName, filterValue]) => {
    if (
      filterValue !== undefined &&
      filterValue !== null &&
      filterValue !== ''
    ) {
      params.append(filterName, String(filterValue));
    }
  });

  return params.toString();
}

export function getQueryParams(param: string): string {
  const params = new URLSearchParams(window.location.search);
  return params.get(param) ?? '';
}

export const updateQueryParam = (
  key: string,
  value: string,
  location: Location,
  navigate: NavigateFunction
) => {
  const params = new URLSearchParams(location.search);
  if (value) {
    params.set(key, value);
  } else {
    params.delete(key);
  }
  navigate(`${location.pathname}?${params.toString()}`, { replace: true });
};

export const deleteQueryParams = (
  keys: string[],
  location: Location,
  navigate: NavigateFunction
) => {
  const params = new URLSearchParams(location.search);
  keys.forEach((key) => params.delete(key));
  navigate(`${location.pathname}?${params.toString()}`, { replace: true });
};
